import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ContactFormPage = () => {
  return (
    <div data-testid="contact-form-page" className="pt-20">
      {/* Hero */}
      <section className="py-16 bg-slate-50">
        <div className="container-main">
          <div className="max-w-3xl mx-auto text-center">
            <Link 
              to="/" 
              className="inline-flex items-center text-sm text-slate-500 hover:text-[#0a1628] transition-colors mb-8"
            >
              <ArrowLeft size={16} className="mr-2" />
              Retour à l'accueil
            </Link>
            <p className="caption-text text-[#BFA15F] mb-4">Contact</p>
            <h1 className="heading-lg mb-6">Parlons de vos enjeux</h1>
            <p className="body-large text-slate-600">
              Remplissez ce formulaire pour que nous puissions échanger 
              sur vos besoins en transformation.
            </p>
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="section-padding bg-white">
        <div className="container-main">
          <div className="max-w-4xl mx-auto flex justify-center">
            <div className="asana-embed-container">
              <link rel="stylesheet" href="https://form.asana.com/static/asana-form-embed-style.css"/>
              <iframe 
                className="asana-embed-iframe" 
                height="533" 
                width="800" 
                src="https://form.asana.com/?k=tLmxaL8qJy4QAdCF1dUkzw&d=1209706784574100&embed=true"
                title="Formulaire de contact"
                style={{ border: 'none', maxWidth: '100%' }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactFormPage;
